import { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate, Link } from 'react-router-dom';

export default function ResultPage() {
  const { categoryId } = useParams();
  const navigate = useNavigate();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const categoryNames = {
    1: 'Ekonomski razvoj',
    2: 'Upravljanje',
    3: 'Ekologija',
    4: 'Inovacije i pametni gradovi',
  };

  useEffect(() => {
    const fetchResult = async () => {
      try {
        const token = localStorage.getItem('token');

        if (!token) {
          alert('Niste prijavljeni.');
          navigate('/login');
          return;
        }

        const res = await axios.get(
          `https://nagradjivanje-api.revicon.info/questionnaire/${categoryId}/result`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        console.log('RESULT DATA:', res.data);
        setData(res.data);
      } catch (err) {
        console.error('Greška prilikom učitavanja rezultata:', err);
        alert('Greška prilikom učitavanja rezultata.');
      } finally {
        setLoading(false);
      }
    };

    fetchResult();
  }, [categoryId, navigate]);

  if (loading) {
    return <p style={{ textAlign: 'center', marginTop: '2rem' }}>Učitavanje rezultata...</p>;
  }

  if (!data) {
    return (
      <div style={{ textAlign: 'center', marginTop: '2rem' }}>
        <p>Nema dostupnih rezultata za ovu kategoriju.</p>
        <Link to={`/questionnaire/${categoryId}`}>Vrati se na upitnik</Link>
      </div>
    );
  }

  const breakdown = Array.isArray(data.breakdown) ? data.breakdown : [];
  const total = Number(data.total || 0);

  return (
    <div
      style={{
        maxWidth: '900px',
        margin: '2rem auto',
        padding: '2rem',
        border: '1px solid #ccc',
        borderRadius: '8px',
        backgroundColor: '#f8f9fa',
        fontFamily: 'Arial, sans-serif',
      }}
    >
      <h2 style={{ textAlign: 'center', marginBottom: '2rem' }}>
        Rezultati - {categoryNames[categoryId] || `Kategorija ${categoryId}`}
      </h2>

      {breakdown.length === 0 ? (
        <p style={{ textAlign: 'center' }}>
          Nema breakdown podataka za ovu kategoriju.
        </p>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse', backgroundColor: '#fff' }}>
          <thead>
            <tr>
              <th style={thStyle}>Oblast</th>
              <th style={thStyle}>Raw score</th>
              <th style={thStyle}>Težina (%)</th>
              <th style={thStyle}>Ponderisani score</th>
            </tr>
          </thead>

          <tbody>
            {breakdown.map((r, i) => {
              const weightedScore = Number(r.weighted_score || 0);

              return (
                <tr key={i}>
                  <td style={tdStyle}>{r.area}</td>
                  <td style={tdStyle}>{r.raw_score}</td>
                  <td style={tdStyle}>{r.weight}%</td>
                  <td style={tdStyle}>{weightedScore.toFixed(2)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}

      <div
        style={{
          textAlign: 'center',
          marginTop: '2rem',
          fontSize: '20px',
          fontWeight: 'bold',
        }}
      >
        Ukupno bodova: {total.toFixed(2)} / 10
      </div>

      <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', marginTop: '2rem' }}>
        <Link to={`/questionnaire/${categoryId}`}>Nazad na upitnik</Link>

        {Number(categoryId) < 4 && (
          <Link to={`/result/${Number(categoryId) + 1}`}>
            Sljedeća kategorija
          </Link>
        )}

        <Link to="/ranking">Ranking</Link>
      </div>
    </div>
  );
}

const thStyle = {
  border: '1px solid #ddd',
  padding: '10px',
  backgroundColor: '#e9ecef',
  textAlign: 'left',
};

const tdStyle = {
  border: '1px solid #ddd',
  padding: '10px',
};